<div class="modal-header">
  <h4 class="modal-title">Add child levels</h4>
</div>
<div class="modal-body">
  <section class="level-fields" [formGroup]="childsForm"> 
      <div formArrayName="childs">
        <ng-container *ngFor="let child of childsArray()?.controls; let i = index">
          <div [formGroupName]="i">
            <input type="text" formControlName="child" class="Fields-input" 
            [ngClass]="(!child.pristine && !!!child.value && childsArray()?.errors?.formInvalid) ?
            'invalid' : 'valid'" placeholder="Level name">    
          </div>
        </ng-container>      
              </div> 
  </section>
  <button type="button" class="btn-secondary add-more-btn" (click)="addMoreFields()">
    Add more fields
  </button>
</div>
<div class="modal-footer">
  <button type="button" class="btn-primary" [disabled]="childsArray()?.errors?.formInvalid" (click)="addNewChilds()">
    Add level(s)
  </button>
  <button type="button" class="btn-secondary" data-dismiss="modal" (click)="cancelPopup()">
    Cancel
  </button>
</div>